import { render } from "./CampaignRetargetingModal.vue?vue&type=template&id=db07b3d4&scoped=true"
import script from "./CampaignRetargetingModal.vue?vue&type=script&lang=js"
export * from "./CampaignRetargetingModal.vue?vue&type=script&lang=js"

import "./CampaignRetargetingModal.vue?vue&type=style&index=0&id=db07b3d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db07b3d4"]])

export default __exports__